import Header from './components/Header';
import Hero from './components/Hero';
import SectionGroupA from './components/SectionGroupA';
import SectionGroupB from './components/SectionGroupB';
import SectionGroupC from './components/SectionGroupC';
import SectionGroupD from './components/SectionGroupD';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionGroupA />
        <SectionGroupB />
        <SectionGroupC />
        <SectionGroupD />
      </main>
      <Footer />
    </>
  );
}